import { cn } from '@xver/utils/classname';
import type { PropsWithChildren } from 'react';

interface IContainerProps extends PropsWithChildren {
    className?: string;
}

export default function Container({ children, className }: IContainerProps) {
    return <div className={cn('w-full max-w-360 mx-auto', className)}>{children}</div>;
}
